import { Box } from '@mui/material';
import { updateDisplayMode } from './../../../../../../config/Services';
import { useContext, useState, useRef, useEffect } from 'react'; // Import useRef and useEffect
import { UserContext } from '../../../../../../App';
import { useNavigate } from 'react-router-dom';
import "./index.css";
import { TvIcon } from '@heroicons/react/24/outline';
import { Squares2X2Icon } from '@heroicons/react/24/outline';
import DisplayKeyboardImg from "../../../../../../assets/images/icons/flags/display-keyboard.png";
import DisplayTouchscreenImg from "../../../../../../assets/images/icons/flags/display-touchscreen.png";
import PosCustomIcon from '../../../../../../customComponents/PosCustomIcon/PosCustomIcon';
import { PosCustomButton } from '../../../../../../customComponents/PosCustomButton/PosCustomButton';
import { useSnackbar } from '../../../hooks/SnackbarProvider';

export const DisplayModeSettings = () => {
  const navigate = useNavigate();
  const [toggleMode, setToggleMode] = useState(localStorage.getItem('mode') || "");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const uidx = retailUserDetails?.uidx
  const { color } = useContext(UserContext);
  const [lastCheckedRef, setLastCheckedRef] = useState(null); // State to store the ref of the last checked input
  const [isLoading, setIsLoading] = useState(false);
  const retailType = localStorage.getItem("retailType");

  const [arrowInd, setArrowInd] = useState(-1); //for arrow clicks

  const showSnackbar = useSnackbar();

  const handleSwitch = () => {
    setIsLoading(true);
    const payload = {
      uidx: uidx,
      displayMode: toggleMode === "KEYPAD" ? "KEYBOARD" : "TOUCHSCREEN"
    }
    updateDisplayMode(payload).then((res) => {
      localStorage.setItem("mode", toggleMode)
      navigate("/settings")
    }).catch((err) => {
      showSnackbar(err?.data?.message || "Error in changing display mode", "error");
    }).finally(() => {
      setIsLoading(false);
    })
  };

  useEffect(() => {
    // Focus the last checked input when the component mounts or when the toggle mode changes
    if (lastCheckedRef) {
      lastCheckedRef.focus();
    }
  }, [lastCheckedRef]);

  const handleKeyPress = (event) => {
    if (event.key === 'ArrowLeft') {
      setArrowInd((prev) => {
        const next = Math.max(-1, prev - 1);
        if (next === 0) {
          setToggleMode("TOUCHSCREEN");
        } else if (next === 1) {
          setToggleMode("KEYPAD");
        }
        return next;
      });
    } else if (event.key === 'ArrowRight') {
      setArrowInd((prev) => {
        const next = Math.min(2, prev + 1);
        if (next === 0) {
          setToggleMode("TOUCHSCREEN");
        } else if (next === 1) {
          setToggleMode("KEYPAD");
        }
        return next;
      });
    } else if (event.key === 'Enter' && (arrowInd === 0 || arrowInd === 1)) {
      handleSwitch();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [toggleMode, arrowInd]);

  const handleRadioChange = (e) => {
    setToggleMode(e.target.value);
    setLastCheckedRef(e.target.checked ? e.target : null); // Update the ref of the last checked input
  };

  const handleModeChange = (selectedMode) => {
    if(retailType === "RESTAURANT") {
      return;
    };
    setToggleMode(selectedMode);
  };

  return (
      <Box
        className="toggle-option-wrapper-modal"
        sx={{
          backgroundColor: color === "dark" ? "#353a50" : "#fff",
          position: "relative",
          height: "100%",
          padding: 2
        }}
      >
        {/* <h4 className="configure-header-txt">Configure your display mode</h4> */}
        {/* <input
          type="radio"
          value="TOUCHSCREEN"
          onChange={handleRadioChange}
          checked={toggleMode === "TOUCHSCREEN"}
          ref={toggleMode === "TOUCHSCREEN" ? setLastCheckedRef : null} // Assign the ref of the last checked input
        />
        <label className="label-toggle-txt">TOUCHSCREEN</label>
        <input
          type="radio"
          value="KEYPAD"
          onChange={handleRadioChange}
          checked={toggleMode === "KEYPAD"}
          ref={toggleMode === "KEYPAD" ? setLastCheckedRef : null} // Assign the ref of the last checked input
        />
        <label className="label-toggle-txt">KEYPAD</label> */}
        
        <div className='display-modes-card-grid'>
          <div
            className={`display-mode-card-par ${toggleMode === "TOUCHSCREEN" && "display-mode-card-par-active"}`}
            onClick={() => handleModeChange("TOUCHSCREEN")}
          >
            <div className='display-mode-card-header' style={{color: "#0B742C"}}>
              <PosCustomIcon 
                icon={<TvIcon />}
                height={"1.25rem"}
                width={"1.25rem"}
                color='"#0B742C"'
              />
              <div>TOUCHSCREEN</div>
            </div>
            <div className='display-mode-card-img-par'>
              <img 
                src={DisplayTouchscreenImg}
                alt='display touchscreen'
                className='display-card-img-div'
              />
            </div>
            <div style={{textAlign: "left"}}>
              {localStorage.getItem('mode') === "TOUCHSCREEN" && `Current display mode is `}
              Touchscreen
            </div>
          </div>
          <div
            className={`display-mode-card-par ${toggleMode === "KEYPAD" && "display-mode-card-par-active"} ${retailType === "RESTAURANT" && "disableMode"}`}
            onClick={() => handleModeChange("KEYPAD")}
          >
            <div className='display-mode-card-header' style={{color: "#E90000"}}>
              <PosCustomIcon 
                icon={<Squares2X2Icon />}
                height={"1.25rem"}
                width={"1.25rem"}
                color='#E90000'
              />
              <div>KEYPAD</div>
            </div>
            <div className='display-mode-card-img-par'>
              <img 
                src={DisplayKeyboardImg}
                alt='display touchscreen'
                className='display-card-img-div'
              />
            </div>
            <div style={{textAlign: "left"}}>
              {localStorage.getItem('mode') === "KEYPAD" && `Current display mode is `}
              Keypad
            </div>
          </div>
        </div>
        <div className="screen-mode-btn-par">
          <PosCustomButton
            variant='blue-d'
            title='Save'
            onClickFunction={handleSwitch}
            disabled={retailType === "RESTAURANT"}
            p={'10px 12px'}
            width='120px'
            fontSize={'1rem'}
            loading={isLoading}
          />
          {/* <button
            className="save-toggle-wrapper-btn"
            onClick={handleSwitch}
            disabled={!toggleMode}
          >
            Save
          </button> */}
        </div>
      </Box>
  );
};
